import axios, { AxiosError, AxiosInstance } from 'axios';

export class AirtableService {
  private apiKey: string;
  private apiBaseUrl: string = 'https://api.airtable.com/v0';

  private api: AxiosInstance | null = null;

  constructor(apiKey: string) {
    this.apiKey = apiKey;
    this.api = axios.create({
      baseURL: this.apiBaseUrl,
      headers: {
        Authorization: `Bearer ${this.apiKey}`,
      },
    });
  }

  public async getUserEmail() {
    try {
      const res = await this.api?.get('/meta/whoami');
      return res?.data?.email;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw new Error(error?.response?.data?.message || error?.message);
      }
      throw new Error('Something went wrong');
    }
  }

  public async getAllUserBases() {
    try {
      const res = await this.api?.get('/meta/bases');
      return res?.data?.bases || [];
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw new Error(error?.response?.data?.message || error?.message);
      }
      throw new Error('Something went wrong');
    }
  }

  public async getBaseTables(baseId: string) {
    try {
      const res = await this.api?.get(`/meta/bases/${baseId}/tables`);
      return res?.data?.tables || [];
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw new Error(error?.response?.data?.message || error?.message);
      }
      throw new Error('Something went wrong');
    }
  }

  public async getTableRecords(
    baseId: string,
    tableId: string,
    filterByFormula: string | null = null,
    offset: string | null = null,
    pageSize: number | null = null,
  ) {
    try {
      let queryParams = `?pageSize=10`; // maximum allowed per request

      if (pageSize) {
        queryParams = `?pageSize=${pageSize}`;
      }

      if (filterByFormula) {
        queryParams += `&filterByFormula=${filterByFormula}`;
      }

      if (offset) {
        queryParams += `&offset=${offset}`;
      }

      const res = await this.api?.get(`${baseId}/${tableId}${queryParams}`);
      return res?.data || [];
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw new Error(error?.response?.data?.message || error?.message);
      }
      throw new Error('Something went wrong');
    }
  }

  public async getTableRecord(
    baseId: string,
    tableId: string,
    recordId: string | null = null,
  ) {
    try {
      const res = await this.api?.get(`${baseId}/${tableId}/${recordId}`);
      return res?.data || {};
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw new Error(error?.response?.data?.message || error?.message);
      }
      throw new Error('Something went wrong');
    }
  }
}
